import {API_URL} from './constant';
import { refreshAccessToken } from './apiClient';

//helper for sending the product list request
async function attemptListProduct(page, page_size,token,searchTerm) {
    const params = new URLSearchParams({
            page,
            page_size: page_size
        })

        if (searchTerm) params.append('search',searchTerm)

        const response  = await fetch(`${API_URL}/products/?${params.toString()}`,{
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        const responseData = await response.json();

        if (!response.ok){
            const err = new Error("Failed to fetch the Product List");
            err.data = responseData;
            err.status = response.status;
            throw err;
        }

        return responseData;
}

// main product list function
export async function listProduct(page, page_size, searchTerm) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptListProduct(page,page_size,accessToken,searchTerm);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptListProduct(page, page_size, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting org list", error?.data || error.message);
        throw error;
    }
}
// helper for sending the add product req
export async function attempAddProduct(data, token) {
    const response = await fetch(`${API_URL}/products/`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    })

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to add Product");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}
// main function to add product
export async function addProduct(data) {
    console.log("Add product data",data)
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempAddProduct(data,accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempAddProduct(data, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while creating the product",error?.data || error.message);
        throw error;
    }
}

// helper for update product
export async function attempUpdateProduct(data,token) {
    const productEditData = {};
    if (data.product_name) productEditData.product_name = data.product_name;
    if (data.default_price) productEditData.default_price = data.default_price;
    if (data.is_active) productEditData.is_active = data.is_active;

    const response = await fetch(`${API_URL}/products/${data.id}/`,{
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(productEditData)
    })

    const responseData = await response.json();

    if (!response.ok){
        const err = new Error("Updating Product failed")
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}   
// main functuion to update the product
export async function updateProduct(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempUpdateProduct(data,accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempUpdateProduct(data,newAccessToken);
            }catch(refreshError){
                console.log("Token refresh Failed", refreshError.message)
                throw refreshError;
            }
        }
        console.log("Error while updating the Product data", error?.data || error.message)
        throw error;
    }
}

// helper function disable product
async function attemptStatusUpdateProduct(data,token) {
    const response = await fetch(`${API_URL}/products/${data}/`,{
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = null;

    if(response.status !== 204){
        responseData = await response.json();
    }
    
    if (!response.ok){
        const err = new Error("Updating Status failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to update the status
export async function statusUpdateProduct(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptStatusUpdateProduct(data,accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptStatusUpdateProduct(data, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);;
                throw refreshError;
            }
        }
        console.log("Error occurred while updating the status",error?.data || error.message);
        throw error;
    }
}